export const GA_CONSTANTS = {
    TOP_UP: 'top_up',
    TRANSFER_OUT: 'transfer_out', // значёк карточки
    REFUND: 'refund',
    CASH_PICKUP: 'cash_pickup',
    INTERAC: 'interac_ca',
    CASH_DELIVERY: 'cash_delivery',
    EXCHANGE: 'exchange',
    OFFLINE_PAYMENT: 'offline_payment',
    CASH_WITHDRAWAL: 'cash_withdrawal',
    GROW_REPAYMENT: 'grow_repayment',
    DELIVERY: 'delivery',
    ONLINE_PAYMENT: 'online_payment',
    UNKNOWN: 'unknown',
    TO_BANK: 'to_bank',
    REPAYMENT: 'repayment',
    CREDIT: 'CREDIT',
    DEBIT: 'DEBIT',
    // Libre
    AGENT_TO_LIBRE: 'agent_to_libre',
    // Card payment · In-store - offline_payment
    // Refund - refund
    // Cash withdrawal - cash_withdrawal
    INTERNAL_TRANSFER_OUT: 'internal_transfer_out', // значёк банка или логотип банка т.е. не нужны мб PISP
    INTERNAL_TRANSFER_IN: 'internal_transfer_in', // значёк банка или логотип банка т.е. не нужны мб PISP
    TRANSFER_IN: 'transfer_in', // аватар или иконка человеска
    INVITE: 'invite', // пока его нет (иконка сердечка) игнорить при выводе
    PAYSEND_LOGO: 'paysend_logo', // хз что это
    REDEMPTION: 'redemption', // как у рефанда
    // countries constants
    GB: 'GB',
    GBP: 'GBP',
    EUR: 'EUR',
} as const;

export type GaConstantKey = keyof typeof GA_CONSTANTS;
export type GaConstantValue = (typeof GA_CONSTANTS)[GaConstantKey];

export const {
    TOP_UP,
    TRANSFER_OUT,
    REFUND,
    CASH_PICKUP,
    INTERAC,
    CASH_DELIVERY,
    EXCHANGE,
    OFFLINE_PAYMENT,
    CASH_WITHDRAWAL,
    GROW_REPAYMENT,
    DELIVERY,
    ONLINE_PAYMENT,
    UNKNOWN,
    TO_BANK,
    REPAYMENT,
    CREDIT,
    DEBIT,
    AGENT_TO_LIBRE,
    INTERNAL_TRANSFER_OUT,
    INTERNAL_TRANSFER_IN,
    TRANSFER_IN,
    INVITE,
    PAYSEND_LOGO,
    REDEMPTION,
    GB,
    GBP,
    EUR,
} = GA_CONSTANTS;

export const TRANSFER_FROM_GT = [TRANSFER_OUT, TO_BANK, INTERAC, CASH_PICKUP, CASH_DELIVERY] as const;
export type TransferFromGtValue = (typeof TRANSFER_FROM_GT)[number];
